const SELECTORS = {
  CONFIG_SCRIPT: "script[data-variant-switch]",
  MAIN_SECTION: ".shopify-section--main-product",
  VARIANT_ITEM: ".variant-drawer--item",
  DRAWER: "#variant-drawer",
};

async function fetchVariantSection(pathname, sectionId, variantId) {
  try {
    const response = await fetch(
      `${pathname}?section_id=${sectionId}&variant=${variantId}`
    );
    if (!response.ok) throw new Error("Network response was not ok");
    return await response.text();
  } catch (error) {
    console.error("Error fetching section:", error);
    return null;
  }
}

function updateVariantUrl(variantId) {
  const url = new URL(window.location.href);
  url.searchParams.set("variant", variantId);
  window.history.replaceState({}, "", url.toString());
}

function dispatchVariantChangeEvent(config, newVariantId, previousVariant) {
  document.dispatchEvent(
    new CustomEvent("variant:change", {
      bubbles: true,
      detail: {
        formId: config.formId,
        variant: {
          id: newVariantId,
          product_id: config.productId,
        },
        previousVariant,
        product: config.product,
      },
    })
  );
}

function attachVariantClickListeners() {
  document.querySelectorAll(SELECTORS.VARIANT_ITEM).forEach((item) => {
    item.addEventListener("click", handleVariantClick);
  });
}

async function handleVariantClick() {
  const configScript = document.querySelector(SELECTORS.CONFIG_SCRIPT);
  const config = configScript ? JSON.parse(configScript.textContent) : null;
  const newVariantId = this.getAttribute("data-variant-id");

  if (!config || !newVariantId) return;

  const form = document.querySelector(`form[id="${config.formId}"]`);
  if (!form) return;

  const previousVariant = {
    id: config.currentVariantId,
    product_id: config.productId,
  };

  updateVariantUrl(newVariantId);

  const html = await fetchVariantSection(
    window.location.pathname,
    config.sectionId,
    newVariantId
  );

  if (!html) return;

  const doc = new DOMParser().parseFromString(html, "text/html");
  const mainProductSection = doc.querySelector(SELECTORS.MAIN_SECTION);

  if (!mainProductSection) return;

  dispatchVariantChangeEvent(config, newVariantId, previousVariant);

  const currentMainProductSection = document.querySelector(
    SELECTORS.MAIN_SECTION
  );
  if (currentMainProductSection) {
    currentMainProductSection.innerHTML = mainProductSection.innerHTML;
    attachVariantClickListeners();
  }

  const drawer = document.querySelector(SELECTORS.DRAWER);
  drawer?.hide();
}

function cleanup() {
  document.querySelectorAll(SELECTORS.VARIANT_ITEM).forEach((item) => {
    item.removeEventListener("click", handleVariantClick);
  });
}

document.addEventListener("DOMContentLoaded", attachVariantClickListeners);
